export const shuffle = (list) => {
    if (!Array.isArray(list) || !list.length) {
        return list;
    }
    return list
        .map(value => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
};
